import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useQuery, useLazyQuery } from "@apollo/client";

import HeaderBox from "../../reuseableComponents/headerBox/HeaderBox";
import ErrorMessage from "../../reuseableComponents/ErrorHandler";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import { GET_EPA_HEALTH_STATS } from "../../../queries/archiveQrys/secureQrys/statewideReportQry";
import EpaViolationCntsTbl from "./EpaViolationCntsTbl";
import EpaHealthCalculationsTbl from "./EpaHealthCalculationsTbl";
import FormalEnforcementActionsTable from "./FormalEnfActionsTable";
import DateRangeForm from "../../reuseableComponents/forms/DateRangeForm";

let initToDate = new Date();
let initToDateFormatted = initToDate.toISOString().split("T")[0];
let initFromDate = new Date(initToDate.getFullYear(), initToDate.getMonth() - 13, 1).toISOString().split("T")[0];

const EpaHealthStatsPage = () => {
  const [formSubmitting, setSubmitting] = useState(false);
  const [vioCounts, setViolationCnts] = useState([]);
  const [epaStats, setEpaStats] = useState([]);
  const [formalEnfCnts, setFormalEnfCnts] = useState([]);
  const { loading, error } = useQuery(GET_EPA_HEALTH_STATS, {
    fetchPolicy: "no-cache",
    onCompleted: (d) => {
      setViolationCnts(d.getEpaHealthCounts[0].EpaViolationCounts);
      setEpaStats(d.getEpaHealthCounts[0].EpaHealthCalcs);
      setFormalEnfCnts(d.getFormalEnforcementActions);
    }
  });
  const [submitDateRange] = useLazyQuery(GET_EPA_HEALTH_STATS);

  const onSubmit = (data) => {
    setSubmitting(true);
    submitDateRange({
      variables: { fromDate: data.fromDate, toDate: data.toDate },
      fetchPolicy: "no-cache",
      onCompleted: (d) => {
        setSubmitting(false);
        setViolationCnts(d.getEpaHealthCounts[0].EpaViolationCounts);
        setEpaStats(d.getEpaHealthCounts[0].EpaHealthCalcs);
        setFormalEnfCnts(d.getFormalEnforcementActions);
      }
    });
  };

  if (loading || error) {
    return (
      <div className='page-container epa-health-stats-container'>
        <Row>
          <Col>
            <Link className='m-2 hyperlink' to='/' cypressid='home-page'>
              Home
            </Link>
            <span className='m-2'>|</span>
            <Link className='m-2 hyperlink' to='/secure/state-wide-reports' cypressid='state-wide-reports'>
              State Wide Reports
            </Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='swr-page'>
              <h3 style={{ color: "#fff" }}>EPA Health Statistics</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <SkeletonLoader width='100%' />
            <ErrorMessage error={error} />
          </Col>
        </Row>
      </div>
    );
  }
  return (
    <div className='page-container epa-health-stats-container'>
      <Row>
        <Col>
          <Link className='m-2 hyperlink' to='/' cypressid='home-page'>
            Home
          </Link>
          <span className='m-2'>|</span>
          <Link className='m-2 hyperlink' to='/secure/module-index' cypressid='module-index'>
            Modules
          </Link>
          <span className='m-2'>|</span>
          <Link className='m-2 hyperlink' to='/secure/state-wide-reports' cypressid='state-wide-reports'>
            State Wide Reports
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='epa-health-stats'>
            <h3 style={{ color: "#fff" }}>EPA Health Statistics</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <DateRangeForm
            onSubmit={onSubmit}
            fromDate={initFromDate}
            toDate={initToDateFormatted}
            formSubmitting={formSubmitting}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormalEnforcementActionsTable data={formalEnfCnts} />
        </Col>
      </Row>
      <Row>
        <Col>
          <EpaViolationCntsTbl data={vioCounts} />
        </Col>
      </Row>
      <Row>
        <Col>
          <EpaHealthCalculationsTbl data={epaStats} />
        </Col>
      </Row>
    </div>
  );
};

export default EpaHealthStatsPage;
